import { FC } from 'react';
import { WrapInLayout } from '../layouts';
import ShippingCarrierList from '../components/shippingCarriers/ShippingCarrierList';

const ShippingCarriersPage: FC = () => (
  <WrapInLayout title="Shipping Carriers" layout="dashboard">
    <h1 className="text-xl font-semibold mb-3">Shipping Carriers</h1>
    <ShippingCarrierList />
  </WrapInLayout>
);

export default ShippingCarriersPage;
